import { Dialog, IconButton, DialogContent } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import React from 'react';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import EditPickupTask from '../edit-task-form/edit-pickup-task-form';

interface MerchantPickupTaskDialogProps {
  onClose: () => void;
  taskID: string;
}
function MerchantPickupTaskDialog({
  taskID,
  onClose,
}: MerchantPickupTaskDialogProps) {
  return (
    <CustomDialog
      open={true}
      fullWidth
      maxWidth="xl"
      fullScreen={(isMobile && !isTablet)}
      onClose={onClose}
    >
      <div
        style={{
          textAlign: 'right',
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <IconButton onClick={onClose}>
          <ClearIcon color="primary" fontSize="large" />
        </IconButton>
      </div>

      <DialogContent style={(isDesktop || isTablet) ? { width: '100%', height: '100%' } : {}}>
        <EditPickupTask taskID={taskID} />
      </DialogContent>
    </CustomDialog>
  );
}

export default MerchantPickupTaskDialog;
